<ngx-extended-pdf-viewer
     [src]="'assets/w9.pdf'"
     [height]="'90vh'"
     [textLayer]="true"
     [showHandToolButton]="true" 
     [filenameForDownload]="'W9_Form.pdf'"
     [zoom]="'auto'"
>
</ngx-extended-pdf-viewer>